import { atom } from 'jotai';
 
export const showBottomNavAtom = atom(true); 